import FileInput from './InterviewRecordingUploader.container';

export default FileInput;
